import { API_ENDPOINT } from "@/constants";
import BaseMixin from "@/mixins/http/Base";
import MatchProblemGroup from "@/models/Agents/MatchProblemGroup";
import MatchProblemProduct from "@/models/Agents/MatchProblemProduct";
import { Component } from "vue-property-decorator";

export enum AgentsMatchProblemGroupMixinTags {
  GetMatchProblems = "get_match_problems",
  GetMatchProblemsGroupProducts = "get_match_problems_group_products",
  ResolveMatchProblemGroup = "resolve_match_problem_group",
}

@Component
export default class AgentsMatchProblemGroupMixin extends BaseMixin {
  getMatchProblemsGroups(
    tag: string,
    slug: string,
    params?: any
  ): Promise<MatchProblemGroup[]> {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT + `/${slug}/agents/match_problem.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getMatchProblemsGroupProducts(
    tag: string,
    slug: string,
    params?: any
  ): Promise<MatchProblemProduct[]> {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_problem/match_problem_group_products.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  resolveMatchProblemGroup(
    tag: string,
    slug: string,
    conflictId: number,
    selectedProductId: string,
    selectedCompanyId: string
  ) {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_problem/resolve_match_problem_group.json`;

    const data = {
      adcontrol_product_id: conflictId as number,
      selected_product_id: selectedProductId,
      selected_company_id: selectedCompanyId,
    };
    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "PATCH",
      data,
    });
  }
}
